<template>
    <div class="wrapper"></div>
</template>

<script>
    import axios from '../axios';

    export default {
        name: "SignIn",
        data() {
            return {}
        },
        watch: {
            role(){
                this.redirectAfterLogin();
            }
        },
        computed: {
            role() {
                if(this.$can('be', 'mechanic')) {
                    return 'mechanic';
                }
                else if (this.$can('be', 'driving_school')) {
                    return 'driving_school';
                }
                else if(this.$can('be', 'dealer')) {
                  return 'dealer';
                }
                else if(this.$can('be', 'broker')) {
                  return 'broker';
                }
                else if(this.$can('be', 'garden')) {
                  return 'garden';
                }
                else if(this.$can('be', 'mutuaide')) {
                   return 'mutuaide';
                }
                else if(this.$can('be', 'representative')  && (this.$store.state.userInfo.representative.id == 15)) {
                  return 'mutuaide_commercial';
                }
                else if(this.$can('be', 'representative')) {
                  return 'representative';
                }
                else if(this.$can('be', 'mutuaide_representative')) {
                  return 'mutuaide_representative';
                }
                else {
                    return 'none';
                }
            }
        },
        methods: {
            redirectAfterLogin() {
                if (this.$can('be', 'mechanic')) {
                    let path = '/';
                    this.$router.push({path});
                }
                if (this.$can('be', 'broker')) {
                  let path = '/';
                  this.$router.push({path});
                }
                if (this.$can('be', 'garden')) {
                  let path = '/';
                  this.$router.push({path});
                }
                if (this.$can('be', 'mutuaide')) {
                  let path = '/';
                  this.$router.push({path});
                }
                if (this.$can('be', 'dealer')) {
                  let path = '/';
                  this.$router.push({path});
                }
                if (this.$can('be', 'driving_school')) {
                  let path = '/double_commande/double_commande_attestation';
                  this.$router.push({path});
                }
                if (this.$can('be', 'mutuaide_commercial')) {
                  let path = '/assistances-souscrites';
                  this.$router.push({path});
                }
              if (this.$can('be', 'representative')  && (this.$store.state.userInfo.representative.id == 15)) {
                let path = '/assistances-souscrites';
                this.$router.push({path});
              }
              else if (this.$can('be', 'representative')) {
                  let path = '/';
                  this.$router.push({path});
                }
                if (this.$can('be', 'mutuaide_representative') && (this.$store.state.userInfo.representative.id == 15)) {
                  let path = '/assistances-souscrites';
                  this.$router.push({path});
                }
                if (this.$can('be', 'mutuaide_representative')) {
                  let path = '/';
                  this.$router.push({path});
                }
            }
        },
        mounted() {
            if (this.$route.params.token) {
                let token = this.$route.params.token;
                axios.get(this.$store.state.baseUrl + '/api/auth/exchange-token', {
                    headers: { 'Authorization': 'Bearer ' + token }
                }).then(response => {
                    this.$ls.setItem('access_token', response.data.access_token);
                    
                    // Trigger App.vue to fetch user info and populate Vuex
                    let appComponent = this.$root.$children.find(c => c.$options.name === 'App') || this.$parent;
                    if (appComponent && typeof appComponent.updateUserInfo === 'function') {
                        appComponent.updateUserInfo();
                    }
                }).catch(() => {
                    window.location.href = this.baseDomain + '/login';
                });
            } else if (!this.$ls.getItem('access_token')) {
                window.location.href = this.baseDomain + '/login'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SignIn.vue